import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {rolesApi} from '../api';
import {getRoleRank} from '../utils';
import {teamKeys} from './useTeamMembersQuery';

/** Unranked (future custom-role) keys sort after every system role. */
function rankWithUnrankedLast(key: string): number {
  return getRoleRank(key) ?? Number.MAX_SAFE_INTEGER;
}

export function useRolesQuery() {
  const client = useApiClient();

  return useQuery({
    queryKey: teamKeys.roles(),
    queryFn: () => rolesApi.fetchRoles(client),
    select: response =>
      [...response.data].sort((a, b) => rankWithUnrankedLast(a.key) - rankWithUnrankedLast(b.key))
  });
}
